import { z } from 'zod';

/**
 * Zod schema for estimation.
 *
 * Represents an estimation with effort bounds.
 */
export const estimationSchema = z.object({
  id: z.number().int().positive(),
  label: z.string(),
  highEffort: z.number().int().optional(),
  lowEffort: z.number().int().optional(),
  priority: z.string(),
  estimationSchemeId: z.number().int().positive(),
});

/**
 * Zod schema for estimation scheme.
 *
 * Represents an estimation scheme configuration.
 */
export const estimationSchemeSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  description: z.string().optional(),
  orgDefault: z.boolean(),
});

export type EstimationDTO = z.infer<typeof estimationSchema>;
export type EstimationSchemeDTO = z.infer<typeof estimationSchemeSchema>;
